(() => {
  if (customElements.get('sansone-free-shipping')) return;

  class SansoneFreeShipping extends HTMLElement {
    static state(cart, threshold = 9900) {
      const total = Number(cart?.total_price);
      const count = Number(cart?.item_count);
      const currency = cart?.currency || 'EUR';
      const visible = Number.isFinite(total) && total >= 0 && Number.isFinite(count) && count > 0 && currency === 'EUR';
      return {
        visible,
        missing: visible ? Math.max(0, threshold - total) : 0,
        percent: visible ? Math.min(100, Math.max(0, total * 100 / threshold)) : 0,
        currency
      };
    }

    connectedCallback() {
      this.update({ total_price: this.dataset.total, item_count: this.dataset.count, currency: this.dataset.currency });
    }

    update(cart) {
      const state = SansoneFreeShipping.state(cart, Number(this.dataset.threshold) || 9900);
      this.hidden = !state.visible;
      if (!state.visible) return;
      this.querySelector('[data-sx-remaining]').hidden = state.missing === 0;
      this.querySelector('[data-sx-unlocked]').hidden = state.missing > 0;
      this.querySelector('[data-sx-amount]').textContent = new Intl.NumberFormat(this.dataset.locale || 'it', {
        style: 'currency', currency: state.currency
      }).format(state.missing / 100);
      this.querySelector('[data-sx-progress]').style.width = `${state.percent}%`;
    }
  }

  customElements.define('sansone-free-shipping', SansoneFreeShipping);
  let revision = 0;

  async function updateShipping(event) {
    const current = ++revision;
    try {
      let cart = event?.cartData;
      if (!Number.isFinite(cart?.item_count) || !Number.isFinite(cart?.total_price)) {
        const root = window.Shopify?.routes?.root || '/';
        const response = await fetch(`${root}cart.js`, { headers: { Accept: 'application/json' }, cache: 'no-store' });
        if (!response.ok) throw new Error('Cart unavailable');
        cart = await response.json();
      }
      if (current !== revision) return;
      document.querySelectorAll('sansone-free-shipping').forEach(element => element.update(cart));
    } catch (_) {
      if (current !== revision) return;
      document.querySelectorAll('sansone-free-shipping').forEach(element => { element.hidden = true; });
    }
  }

  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, updateShipping);
  }
  window.addEventListener('pageshow', event => { if (event.persisted) updateShipping(); });
})();
